import * as P from 'plow-js';
import { createReducer } from 'redux-act';
// common
import { updateReportFromReportListSuccess } from '../../common/actions';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// report-common
import { getReportReducers } from '../../report-common';
// feature edi-integration
import * as A from './actions';
//////////////////////////////////////////////////

const initial = {
  filterProps: [],
  globalFilterValue: '',
};

const {
  selectItem,
  setReports,
  initialState,
  setListLoading,
  setInitialState,
  setReportPending,
  getItemListSuccess,
  resetListAndPagination,
  setInitialStateOmitReport,
  handleUpdateReportFromReportListSuccess,
} = getReportReducers(initial);

const setFilterProps = (state, data) => P.$set('filterProps', data, state);

const setUsedReport = (state, data) => (
  P.$all(
    P.$set('totalCount', 0),
    P.$set('itemList', null),
    P.$set('usedReport', data),
    P.$set('titleSortValues', {}),
    P.$set('reportPending', false),
    P.$set('tableTitleFilters', {}),
    P.$set('globalFilterValue', ''),
    P.$set('pagination', initialState.pagination),
    state,
  )
);

const acceptLoadFromEDISuccess = (state, { transactionGuid, status }) => (
  P.$set(`itemList.${transactionGuid}.${GC.FIELD_EDI_STATUS}`, status, state)
);

const declineLoadFromEDISuccess = (state, { transactionGuid, status }) => (
  P.$set(`itemList.${transactionGuid}.${GC.FIELD_EDI_STATUS}`, status, state)
);

const setCloLoadFromEDIStatus = (state, { transactionGuid, status }) => (
  P.$set(`itemList.${transactionGuid}.${GC.FIELD_CLO}.${GC.FIELD_STATUS}`, status, state)
);

const setExternalIdFilter = (state, externalId) => (
  P.$set('externalIdFilter', externalId, state)
);

export default createReducer({
  [A.setReports]: setReports,
  [A.selectItem]: selectItem,
  [A.setUsedReport]: setUsedReport,
  [A.setFilterProps]: setFilterProps,
  [A.setListLoading]: setListLoading,
  [A.setInitialState]: setInitialState,
  [A.setReportPending]: setReportPending,
  [A.getItemListSuccess]: getItemListSuccess,
  [A.setTableTitleSort]: G.setTableTitleSort,
  [A.setExternalIdFilter]: setExternalIdFilter,
  [A.setTableTitleFilter]: G.setTableTitleFilter,
  [A.resetListAndPagination]: resetListAndPagination,
  [A.setCloLoadFromEDIStatus]: setCloLoadFromEDIStatus,
  [A.acceptLoadFromEDISuccess]: acceptLoadFromEDISuccess,
  [A.setInitialStateOmitReport]: setInitialStateOmitReport,
  [A.declineLoadFromEDISuccess]: declineLoadFromEDISuccess,
  [updateReportFromReportListSuccess]: handleUpdateReportFromReportListSuccess,
}, initialState);
